const State = {
    batteryProductData:{},
    vehicleData:{},
    interventionData:{},
}

export default State;